/**
 * The scope table of the settings service, as the console needs it.
 *
 * The list lived in two places that disagreed: the card renderer knew about
 * `phone` (id 5) and the drawer's dropdown did not, so a phone-scoped override
 * could be displayed and never created. One list, used by both.
 */

export interface FlagScope {
  id: number;
  /** The `scope_code` the API expects when writing an override. */
  code: string;
  labelKey: string;
}

export const FLAG_SCOPES: FlagScope[] = [
  { id: 1, code: 'global', labelKey: 'settings.flags.scope.global' },
  { id: 2, code: 'country', labelKey: 'settings.flags.scope.country' },
  { id: 3, code: 'org', labelKey: 'settings.flags.scope.org' },
  { id: 4, code: 'sub_account', labelKey: 'settings.flags.scope.subAccount' },
  { id: 5, code: 'phone', labelKey: 'settings.flags.scope.phone' },
  { id: 6, code: 'user', labelKey: 'settings.flags.scope.user' }
];

export function scopeName(id: number): string {
  return FLAG_SCOPES.find((s) => s.id === id)?.code ?? `scope_${id}`;
}

/**
 * A `killswitch` tag and an `experiment` tag carry very different consequences
 * and used to be the same shade of blue.
 */
export function tagTone(tag: string): string {
  const normalised = tag.toLowerCase();
  if (normalised === 'killswitch') return 'red';
  if (normalised === 'experiment') return 'blue';
  if (normalised === 'ops') return 'gray';
  return 'gray';
}
